<div class=" col-sm-2   col-md-3 col-lg-3 d-flex flex-column text-sm-end text-md-start  align-items-lg-start left_sidebar border-end ">
    <div class="d-flex align-items-center justify-content-sm-end justify-content-md-start menu-item logo-img" routerLinkActive="active">
        <span>
            <a routerLink="/dashboard" routerLinkActive="active-link">
                <img src="assets/public/images/mainlogo_lg.png" alt="Truth Shorts Logo" width="40" height="40" style="object-fit:contain" />
            </a>
        </span>
    </div>
    <div class="d-flex align-items-center justify-content-sm-end justify-content-md-start menu-item pt-3" routerLinkActive="active" style="padding-bottom:10px;">
        <a routerLink="/dashboard" routerLinkActive="active-link" style="display: flex;">
            <span>
                <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" class="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-1nao33i r-lwhw9o r-cnnz9e">
                    <g>
                        <path d="M21.591 7.146L12.52 1.157c-.316-.21-.724-.21-1.04 0l-9.071 5.99c-.26.173-.409.456-.409.757v13.183c0 .502.418.913.929.913h6.638c.511 0 .929-.41.929-.913v-7.075h3.008v7.075c0 .502.418.913.929.913h6.639c.51 0 .928-.41.928-.913V7.904c0-.301-.158-.584-.408-.758zM20 20l-4.5.01.011-7.097c0-.502-.418-.913-.928-.913H9.44c-.511 0-.929.41-.929.913L8.5 20H4V8.773l8.011-5.342L20 8.764z" style="fill:currentColor">
                        </path>
                    </g>
                </svg>
                <!--</a>-->
            </span>
            <span class="d-none d-md-inline-block fs-5 ps-2">
                Home
            </span>
        </a>
    </div>
    <div class="d-flex align-items-center justify-content-sm-end justify-content-md-start menu-item pt-3" routerLinkActive="active" style="padding-bottom:10px;">
        <a routerLink="/explore" routerLinkActive="active-link" style="display: flex;">
            <span>
                <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" class="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-1nao33i r-lwhw9o r-cnnz9e">
                    <g>
                        <path d="M10.25 3.75c-3.59 0-6.5 2.91-6.5 6.5s2.91 6.5 6.5 6.5c1.795 0 3.419-.726 4.596-1.904 1.178-1.177 1.904-2.801 1.904-4.596 0-3.59-2.91-6.5-6.5-6.5zm-8.5 6.5c0-4.694 3.806-8.5 8.5-8.5s8.5 3.806 8.5 8.5c0 1.986-.682 3.815-1.824 5.262l4.781 4.781-1.414 1.414-4.781-4.781c-1.447 1.142-3.276 1.824-5.262 1.824-4.694 0-8.5-3.806-8.5-8.5z" style="fill:currentColor">
                        </path>
                    </g>
                </svg>
            </span>
            <span class="d-none d-md-block fs-5 ps-2">
                Explore
            </span>
        </a>
    </div>
    <div class="d-flex align-items-center justify-content-sm-end justify-content-md-start menu-item pt-3" routerLinkActive="active" style="padding-bottom:10px;">
        <a routerLink="/notifications" routerLinkActive="active-link" style="display: flex;">
            <span>
                <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" class="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-1nao33i r-lwhw9o r-cnnz9e">
                    <g>
                        <path d="M19.993 9.042C19.48 5.017 16.054 2 11.996 2s-7.49 3.021-7.999 7.051L2.866 18H7.1c.463 2.282 2.481 4 4.9 4s4.437-1.718 4.9-4h4.236l-1.143-8.958zM12 20c-1.306 0-2.417-.835-2.829-2h5.658c-.412 1.165-1.523 2-2.829 2zm-6.866-4l.847-6.698C6.364 6.272 8.941 4 11.996 4s5.627 2.268 6.013 5.295L18.864 16H5.134z" style="fill:currentColor">
                        </path>
                    </g>
                </svg>
            </span>
            <span class="d-none d-md-block fs-5 ps-2">
                Notifications
            </span>
        </a>
    </div>
    <div class="d-flex align-items-center justify-content-sm-end justify-content-md-start menu-item pt-3" routerLinkActive="active" style="padding-bottom:10px;">
        <a routerLink="/notifications" routerLinkActive="active-link" style="display: flex;">
            <span>
                <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" class="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-1nao33i r-lwhw9o r-cnnz9e">
                    <g>
                        <path d="M1.998 5.5c0-1.381 1.119-2.5 2.5-2.5h15c1.381 0 2.5 1.119 2.5 2.5v13c0 1.381-1.119 2.5-2.5 2.5h-15c-1.381 0-2.5-1.119-2.5-2.5v-13zm2.5-.5c-.276 0-.5.224-.5.5v2.764l8 3.638 8-3.636V5.5c0-.276-.224-.5-.5-.5h-15zm15.5 5.463l-8 3.636-8-3.638V18.5c0 .276.224.5.5.5h15c.276 0 .5-.224.5-.5v-8.037z" style="fill:currentColor">
                        </path>
                    </g>
                </svg>
            </span>
            <span class="d-none d-md-block fs-5 ps-2">
                Messages
            </span>
        </a>
    </div>
    <div class="d-flex align-items-center justify-content-sm-end justify-content-md-start menu-item pt-3" routerLinkActive="active" style="padding-bottom:10px;">
        <!--<a routerLink="['/', Username]" routerLinkActive="active-link" style="display: flex;">-->
        <a (click)="navigateToProfile()"
           [ngClass]="{ 'active-link': isProfileActive() }"
           style="display: flex;">
            <span>
                <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" class="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-1nao33i r-lwhw9o r-cnnz9e">
                    <g>
                        <path d="M5.651 19h12.698c-.337-1.8-1.023-3.21-1.945-4.19C15.318 13.65 13.838 13 12 13s-3.317.65-4.404 1.81c-.922.98-1.608 2.39-1.945 4.19zm.486-5.56C7.627 11.85 9.648 11 12 11s4.373.85 5.863 2.44c1.477 1.58 2.366 3.8 2.632 6.46l.11 1.1H3.395l.11-1.1c.266-2.66 1.155-4.88 2.632-6.46zM12 4c-1.105 0-2 .9-2 2s.895 2 2 2 2-.9 2-2-.895-2-2-2zM8 6c0-2.21 1.791-4 4-4s4 1.79 4 4-1.791 4-4 4-4-1.79-4-4z" style="fill:currentColor">
                        </path>
                    </g>
                </svg>
            </span>
            <span class="d-none d-md-block fs-5 ps-2">
                <!--<a [routerLink]="'/' + Username">Profile</a>-->
                Profile
            </span>
        </a>
    </div>
    <!--                    <p class="d-none d-md-block fs-6 pt-3 ps-2"><a routerLink="/{{Username}}">Profile</a></p>-->
    <div class="d-flex align-items-center justify-content-sm-end justify-content-md-start menu-item pt-3" routerLinkActive="active" style="padding-bottom:10px;">
        <a routerLink="/notifications" routerLinkActive="active-link" style="display: flex;">
            <span>
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 1694.235h1920V226H0v1468.235ZM112.941 376.664V338.94H1807.06v37.723L960 1111.233l-847.059-734.57ZM1807.06 526.198v950.513l-351.134-438.89-88.32 70.475 378.353 472.998H174.042l378.353-472.998-88.32-70.475-351.134 438.89V526.198L960 1260.768l847.059-734.57Z" fill-rule="evenodd" style="fill:currentColor" />
                </svg>
            </span>
            <span class="d-none d-md-block fs-5 ps-2">
                <!--<a routerLink="/dashboard_login">Dashboard Login</a>-->
                Dashboard Login
            </span>
        </a>
    </div>
    <div class="d-flex align-items-center justify-content-sm-end justify-content-md-start menu-item pt-3" routerLinkActive="active" style="padding-bottom:10px;">
        <a routerLink="/notifications" routerLinkActive="active-link" style="display: flex;">

            <span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12M21 12C21 7.02944 16.9706 3 12 3M21 12H19M3 12C3 7.02944 7.02944 3 12 3M3 12H5M12 3V5M13.3229 10.5C12.9703 10.1888 12.5072 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 11.4027 13.7381 10.8665 13.3229 10.5ZM13.3229 10.5L15.8229 8" stroke="#000000" stroke-width="2" stroke-linecap="round" style="fill:currentColor" />
                </svg>
            </span>
            <span class="d-none d-md-block fs-5 ps-2">
                <!--<a routerLink="/admin_dashboard">Admin Dashboard</a>-->
                Admin Dashboard
            </span>
        </a>
    </div>
    <div class="d-flex align-items-center justify-content-sm-end justify-content-md-start menu-item pt-3" routerLinkActive="active" style="padding-bottom:10px;">
        <a routerLink="/notifications" routerLinkActive="active-link" style="display: flex;">
            <span class="col-1"><i class="fa fa-ellipsis-h fs-5 py-3"></i></span>
            <span class="d-none d-md-block fs-5 pt-3 ps-2">
                More
            </span>
        </a>
    </div>



    <div class="d-flex align-items-center justify-content-sm-end justify-content-md-start pt-3" routerLinkActive="active" style="padding-bottom:10px;">
        <button class="text-decoration-none fs-6  fw-bold text-white bg-gray py-1 px-3  rounded-pill"
                (click)="openPostSubmitModal()">
            Post
        </button>
    </div>



</div>
